import './code.sass'
import hljs from 'highlight.js'
import redent from 'redent'

export default {
  props: {
    lang: {
      type: String,
      default: 'html'
    }
  },
  render (h) {
    if ('default' in this.$scopedSlots === false) return

    // console.log(this.$scopedSlots.default()[0].text)
    // this.$scopedSlots.default()[0].text
    // console.log(this.$slots.default)
    const { lang } = this
    const code = this.$scopedSlots.default()[0].children[0].text
    const parsed = redent(code, 0).trim()
    const html = hljs
      .highlight(parsed, { language: lang })
      .value

    return h('pre', {
      class: 'code-pre'
    }, [
      h('code', {
        class: ['hljs', lang, 'bg-transparent'],
        domProps: {
          innerHTML: html
        }
      })
    ])
  }
}
